/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Edit_Contribution_RulesInputs */

const fr_vehicle_action_edit_contribution_rules = /** @type {(inputs: Vehicle_Action_Edit_Contribution_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`des règles de contribution`)
};

const en_vehicle_action_edit_contribution_rules = /** @type {(inputs: Vehicle_Action_Edit_Contribution_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the contribution rules`)
};

/**
* | output |
* | --- |
* | "the contribution rules" |
*
* @param {Vehicle_Action_Edit_Contribution_RulesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_contribution_rules = /** @type {((inputs?: Vehicle_Action_Edit_Contribution_RulesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_Contribution_RulesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_contribution_rules(inputs)
	return en_vehicle_action_edit_contribution_rules(inputs)
});